import payload_plugin_e0k4tW9bdI from "/vercel/path0/node_modules/nuxt-vuefire/dist/runtime/payload-plugin.mjs";
import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_7pzUtwM1Zj from "/vercel/path0/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.mjs";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/vercel/path0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import pinceau_nuxt_plugin_client_bfcCy9a5iq from "/vercel/path0/.nuxt/pinceau-nuxt-plugin.client.mjs";
import plugin_client_i8AMfKeYnY from "/vercel/path0/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.mjs";
import i18n_yfWm7jX06p from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_client_j7wLaRg9eH from "/vercel/path0/node_modules/@samk-dev/nuxt-vcalendar/dist/runtime/plugin.client.mjs";
import plugin_client_mik7N71GmK from "/vercel/path0/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.mjs";
import vuefire_auth_plugin_client_cCwkwh1j5u from "/vercel/path0/.nuxt/vuefire-auth-plugin.client.mjs";
import plugin_mint_cookie_client_xgxXjNHXgE from "/vercel/path0/node_modules/nuxt-vuefire/dist/runtime/auth/plugin-mint-cookie.client.mjs";
import vuefire_plugin_8cq4FnzXKb from "/vercel/path0/.nuxt/vuefire-plugin.mjs";
import plugin_client_fJcP4agYwv from "/vercel/path0/node_modules/nuxt-vercel-analytics/dist/runtime/plugin.client.mjs";
import plugin_tbFNToZNim from "/vercel/path0/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import preview_client_DXs5LYnWiu from "/vercel/path0/node_modules/@nuxthq/studio/dist/runtime/plugins/preview.client.mjs";
import documentDriven_cMiI6j6ghD from "/vercel/path0/node_modules/@nuxt/content/dist/runtime/legacy/plugins/documentDriven.js";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import menu_13PGuw7IWk from "/vercel/path0/node_modules/@nuxt-themes/docus/plugins/menu.ts";
import scrollbars_client_28fjMYE4EU from "/vercel/path0/node_modules/@nuxt-themes/docus/plugins/scrollbars.client.ts";
import analytics_client_mtqVw3YRXk from "/vercel/path0/plugins/analytics.client.ts";
export default [
  payload_plugin_e0k4tW9bdI,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_7pzUtwM1Zj,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  pinceau_nuxt_plugin_client_bfcCy9a5iq,
  plugin_client_i8AMfKeYnY,
  i18n_yfWm7jX06p,
  plugin_client_j7wLaRg9eH,
  plugin_client_mik7N71GmK,
  vuefire_auth_plugin_client_cCwkwh1j5u,
  plugin_mint_cookie_client_xgxXjNHXgE,
  vuefire_plugin_8cq4FnzXKb,
  plugin_client_fJcP4agYwv,
  plugin_tbFNToZNim,
  preview_client_DXs5LYnWiu,
  documentDriven_cMiI6j6ghD,
  chunk_reload_client_UciE0i6zes,
  menu_13PGuw7IWk,
  scrollbars_client_28fjMYE4EU,
  analytics_client_mtqVw3YRXk
]